import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './index.css';

export interface IRulerControlsProps {
  onRulerToggle(): void;
  isSelected: boolean;
}

export class RulerControls extends React.Component<IRulerControlsProps> {
  public render() {
    const { isSelected, onRulerToggle } = this.props;

    return (
      <div {...mergeStyles(styles['container'], isSelected && styles['container--active'])} onClick={onRulerToggle}>
        <div className={styles['icon']} />
      </div>
    );
  }
}
